import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import {
    FETCH_ALL_PROMOTION,
    UPDATE_PROMOTION,
    CREATE_PROMOTION, DELETE_PROMOTION
} from 'constants/promotions.constants'
import axios from 'axios'
import {
    fetchPromotionsSuccess,
    updatePromotionSuccess,
    createPromotionSuccess,
    deletePromotionSuccess
} from "actions/promotions.action";
import { showErrors, stopLoader } from "actions/general.action";


// promotion sagas

const fetchPromotionsRequest = async (page) => {
    return axios.get('/api/v1/super_admin/promotions');
}

function* fetchPromotions({ payload }) {
    try {
        const reuslt = yield call(fetchPromotionsRequest, payload);
        if (reuslt.message) {
            yield put(showErrors(reuslt.message));
        } else {
            yield put(fetchPromotionsSuccess(reuslt.data));
            yield put(stopLoader())
        }
    } catch (error) {
        yield put(showErrors(error.message));
    }
}

const updatePromotionsRequest = async (payload) => {
    let o = Object.assign({}, payload);
    o.doctor_category = {id: payload.doctor_category_id}
    o.applicable_area = {id: payload.applicable_area_id}

    return axios.put('/api/v1/super_admin/promotions/' + payload.id,
        o
    );
}

function* updatePromotion({ payload }) {
    try {
        const reuslt = yield call(updatePromotionsRequest, payload);
        if (reuslt.message) {
            yield put(showErrors(reuslt.message));
        } else {
            yield put(updatePromotionSuccess(reuslt.data));
            yield put(stopLoader())
        }
    } catch (error) {
        yield put(showErrors(error.message));
    }
}

const createPromotionsRequest = async (payload) => {
    let o = Object.assign({}, payload);
    o.doctor_category = {id: payload.doctor_category_id}
    o.applicable_area = {id: payload.applicable_area_id}

    return axios.post('/api/v1/super_admin/promotions',
        o
    );
}

function* createPromotion({ payload }) {
    try {
        const reuslt = yield call(createPromotionsRequest, payload);
        if (reuslt.message) {
            yield put(showErrors(reuslt.message));
        } else {
            yield all([
                put(createPromotionSuccess(reuslt.data)),
                //put(stopLoader("Promotion created"))
            ])
        }
    } catch (error) {
        yield put(showErrors(error.message));
    }
}

const deletePromotionsRequest = async (id) => {
    return axios({
        method: "delete",
        url: '/api/v1/super_admin/promotions/' + id,
        headers: {
          'Content-Type': 'text/plain'
        },
        data: "",
    });
}

function* deletePromotion({ payload }) {
    try {
        const reuslt = yield call(deletePromotionsRequest, payload);
        if (!reuslt.status) {
            yield put(showErrors(reuslt.message));
        } else {
            yield put(deletePromotionSuccess(reuslt.data));
            yield put(stopLoader())
        }
    } catch (error) {
        yield put(showErrors(error.message));
    }
}


// fork promotion
export function* forkFetchPromotions() {
    yield takeEvery(FETCH_ALL_PROMOTION, fetchPromotions);
}

export function* forkUpdatePromotion() {
    yield takeEvery(UPDATE_PROMOTION, updatePromotion);
}

export function* forkCreatePromotion() {
    yield takeEvery(CREATE_PROMOTION, createPromotion);
}

export function* forkDeletePromotion() {
    yield takeEvery(DELETE_PROMOTION, deletePromotion);
}


export default function* rootSaga() {
    yield all([
        fork(forkFetchPromotions),
        fork(forkUpdatePromotion),
        fork(forkCreatePromotion),
        fork(forkDeletePromotion),
    ]);
}